module.exports = __webpack_public_path__ + "img/privacy_icon.e4810e3d.png";